import { Unsubscribable } from "rxjs";

// different apps may have different list of parameters, treated as 'root'.
// this is injection token to provide app-specific root params.
export const APP_ROOT_PARAMS ="app_root_params";
export abstract class RootParametersProvider {

  public abstract notifyListeners(topic: string, value:any);
  /**
   * In some very rare cases people want to update several topics 'at once'.
   * Normally this is done by calling notifyListeners(topic) for each topic.
   * However this scenario fails to work correctly if root parameters provider is based on URL:
   * - updating those parameters one by another is triggering multiple navigation events.
   * - And angular takes care to cancel navigation, if there is a rapid shot of navigations/and previous
   *   one is not yet over).
   * By using 'notifyMultipleListeners' method we can conveniently group those updates into one navigation event.
   */
  public abstract notifyMultipleListeners(multiple: {});
  /**
   * A common use pattern was found: the code was publishing a value for root parameter and then triggering
   * navigation. While this is working fine in case root parameters are stored in values.exchange.provider,
   * it fails when root parameters are stored on the URL. The reason? Update of parameter value on URL
   * is triggering router navigation event. Then user' code is firing another navigation event - and the first
   * one is not yet done. Thus one of events is simply cancelled.
   * This method is trying to solve this problem:
   * - for subject based implementations it shoots the value 'as usual';
   * - for url based implementations nothing is emitted to URL. Instead, the value is packed into format, suitable for
   * injection into URL at the next navigation. I do not recommend to call this method directly from widgets.
   * Instead, I recommend to use NavigationProvider::addRootParam() to publish values for your root parameters.
   * Then, the navigation implementation will take care to do the rest.
   */
  public abstract notifyListenersBeforeRouteChange(topic: string, value:any):any;

  /**
   * Should return last known value for that topic.
   */
  public abstract getLastKnownValue(topic: string):any;
}
